import { PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

import { StepItem } from "../../../shared/components/Steps";
import { PAYROLL_RUN_APPROVAL_STAGES } from "../constants";

/**
 * Maps a v3 `PayrollRunStatus` to the index of the stage that is currently
 * active within the ordered approval window (Open → Approval → Finalized →
 * Paid). `activeIndex` past the last stage means every stage is complete.
 *
 * NOTE: `Draft` sits on "Approval" and `PendingApprovals` on "Open" — that is
 * the mapping this screen has always rendered, kept as-is here. It reads
 * inverted and is worth confirming against the design.
 */
const STATUS_TO_ACTIVE_STAGE: Record<
  PayrollRunStatus,
  { activeIndex: number; failed?: boolean }
> = {
  [PayrollRunStatus.PENDING_APPROVALS]: { activeIndex: 0 },
  [PayrollRunStatus.DRAFT]: { activeIndex: 1 },
  [PayrollRunStatus.FINALIZED]: { activeIndex: 2 },
  [PayrollRunStatus.PROCESSING]: { activeIndex: 2 },
  [PayrollRunStatus.PAID]: { activeIndex: PAYROLL_RUN_APPROVAL_STAGES.length },
  [PayrollRunStatus.PARTIALLY_PAID]: { activeIndex: 0 },
  [PayrollRunStatus.CANCELLED]: { activeIndex: 1, failed: true },
  [PayrollRunStatus.FAILED]: { activeIndex: 1, failed: true }
};

export const selectorPayrollRunApprovalSteps = (
  status?: PayrollRunStatus
): StepItem[] => {
  const { activeIndex, failed } =
    STATUS_TO_ACTIVE_STAGE[status ?? PayrollRunStatus.PENDING_APPROVALS];

  return PAYROLL_RUN_APPROVAL_STAGES.map((title, index) => {
    if (index < activeIndex) {
      return { title, status: "Complete" };
    }

    if (index === activeIndex) {
      return { title, status: failed ? "Failed" : "Active" };
    }

    return { title, status: "Pending" };
  });
};
